import { useTranslation } from 'react-i18next'

export type MediaSize = 'S' | 'M' | 'L'

interface Props {
  size: MediaSize
  onChange: (s: MediaSize) => void
}

const OPTIONS: MediaSize[] = ['S', 'M', 'L']

export function MediaSizeToggle({ size, onChange }: Props) {
  const { t } = useTranslation()
  return (
    <div
      role="group"
      aria-label={t('addToProduct.media.size.label')}
      className="inline-flex gap-1 rounded-lg border border-neutral-200 dark:border-neutral-800 p-0.5"
    >
      {OPTIONS.map((s) => (
        <button
          key={s}
          type="button"
          aria-pressed={size === s}
          onClick={() => onChange(s)}
          className={`px-2 py-1 text-xs rounded ${
            size === s
              ? 'bg-primary-500 text-white'
              : 'text-neutral-600 dark:text-neutral-400'
          }`}
        >
          {t(`addToProduct.media.size.${s.toLowerCase()}`)}
        </button>
      ))}
    </div>
  )
}
